<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import { isTempleModule } from '@utils'

export default {
  page: {
    title: '訂單查詢',
    meta: [{ name: 'description', container: 'Order List' }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      activeTab: '0',
      tabList: Object.freeze([
        {
          title: '預約報名',
          component: () => lazyLoadComponent(import('./TabProduct')),
        },
        {
          title: '預付方案',
          component: () => lazyLoadComponent(import('./TabPrepaid')),
        },
      ]),
    }
  },
  methods:{
    isTempleModule
  }
}
</script>

<template>
  <Layout>
    <BasePageHeader>
      <template v-slot:title>訂單查詢</template>
      <!-- <template v-slot:right>
        <el-tabs v-model="activeTab" class="is-no-border">
          <el-tab-pane
            v-for="(tab, index) in tabList"
            :key="index"
            :label="tab.title"
            :name="`${index}`"
          ></el-tab-pane>
        </el-tabs>
      </template> -->
    </BasePageHeader>
    <keep-alive>
      <component :is="tabList[activeTab].component"></component>
    </keep-alive>
  </Layout>
</template>
